import React from 'react'
import {Container} from 'react-bootstrap'

const About = () => {
    const bio = 'Abby Cheung is the owner and CEO of the SaveYOU Kit.  She was inspired to create a product that will save everyone’s time, money, space, and energy. After seeing her dad’s overflowing medical travel bag, the CEO wanted to develop a kit that was compact-able and contained all the necessities needed for vacation. She knows she’d rather be by the beach with her SaveYOU Kit nearby, then spending 3 hours in an urgent care getting treated for a headache!'
    const companyBio = 'The SaveYOU Kit is a practical, compact, and functional kit to treat minor travel emergencies. It includes a range of necessities from a grooming kit and a multipurpose tool to band aids and ointments. The SaveYOU Kit contains over 40 items of medical and general necessities.'

  return (
    <Container className='mt-5 mb-5' style={{ display: 'flex', alignItems: 'center' }}>
    <img src={require('./profile.png')} alt="Profile Picture" style={{ width: '35%', marginRight: '20px' }} />
    <div style={{ width: '65%'}}>
      <h4>About the Founder</h4>
      <p>{bio}</p>
      <h4>About the Company</h4>
      <p>{companyBio}</p>
    </div>
  </Container>
  )
}

export default About